import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteOmiliaRequestType($id: ID!) {
  deleteOmiliaRequestType(id: $id){
    id
  }
}`;

function deleteOmiliaRequestType(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteOmiliaRequestType);
}

export default deleteOmiliaRequestType;
